import Odometer from 'odometer';
import lightbox2 from "lightbox2";
import 'bootstrap';
import {InfobipApiData, InfobipApiCall} from '../components/infobipApi';


let customJquery = () => {

	let module = {},
		init = () => {

			/*
            * jquery-match-height 0.7.2 by @liabru
            * http://brm.io/jquery-match-height/
            * License MIT
            */
			!function(t){"use strict";"function"==typeof define&&define.amd?define(["jquery"],t):"undefined"!=typeof module&&module.exports?module.exports=t(require("jquery")):t(jQuery)}(function(t){var e=-1,o=-1,n=function(t){return parseFloat(t)||0},a=function(e){var o=1,a=t(e),i=null,r=[];return a.each(function(){var e=t(this),a=e.offset().top-n(e.css("margin-top")),s=r.length>0?r[r.length-1]:null;null===s?r.push(e):Math.floor(Math.abs(i-a))<=o?r[r.length-1]=s.add(e):r.push(e),i=a}),r},i=function(e){var o={
				byRow:!0,property:"height",target:null,remove:!1};return"object"==typeof e?t.extend(o,e):("boolean"==typeof e?o.byRow=e:"remove"===e&&(o.remove=!0),o)},r=t.fn.matchHeight=function(e){var o=i(e);if(o.remove){var n=this;return this.css(o.property,""),t.each(r._groups,function(t,e){e.elements=e.elements.not(n)}),this}return this.length<=1&&!o.target?this:(r._groups.push({elements:this,options:o}),r._apply(this,o),this)};r.version="0.7.2",r._groups=[],r._throttle=80,r._maintainScroll=!1,r._beforeUpdate=null,
				r._afterUpdate=null,r._rows=a,r._parse=n,r._parseOptions=i,r._apply=function(e,o){var s=i(o),h=t(e),l=[h],c=t(window).scrollTop(),p=t("html").outerHeight(!0),u=h.parents().filter(":hidden");return u.each(function(){var e=t(this);e.data("style-cache",e.attr("style"))}),u.css("display","block"),s.byRow&&!s.target&&(h.each(function(){var e=t(this),o=e.css("display");"inline-block"!==o&&"flex"!==o&&"inline-flex"!==o&&(o="block"),e.data("style-cache",e.attr("style")),e.css({display:o,"padding-top":"0",
				"padding-bottom":"0","margin-top":"0","margin-bottom":"0","border-top-width":"0","border-bottom-width":"0",height:"100px",overflow:"hidden"})}),l=a(h),h.each(function(){var e=t(this);e.attr("style",e.data("style-cache")||"")})),t.each(l,function(e,o){var a=t(o),i=0;if(s.target)i=s.target.outerHeight(!1);else{if(s.byRow&&a.length<=1)return void a.css(s.property,"");a.each(function(){var e=t(this),o=e.attr("style"),n=e.css("display");"inline-block"!==n&&"flex"!==n&&"inline-flex"!==n&&(n="block");var a={
				display:n};a[s.property]="",e.css(a),e.outerHeight(!1)>i&&(i=e.outerHeight(!1)),o?e.attr("style",o):e.css("display","")})}a.each(function(){var e=t(this),o=0;s.target&&e.is(s.target)||("border-box"!==e.css("box-sizing")&&(o+=n(e.css("border-top-width"))+n(e.css("border-bottom-width")),o+=n(e.css("padding-top"))+n(e.css("padding-bottom"))),e.css(s.property,i-o+"px"))})}),u.each(function(){var e=t(this);e.attr("style",e.data("style-cache")||null)}),r._maintainScroll&&t(window).scrollTop(c/p*t("html").outerHeight(!0)),
				this},r._applyDataApi=function(){var e={};t("[data-match-height], [data-mh]").each(function(){var o=t(this),n=o.attr("data-mh")||o.attr("data-match-height");n in e?e[n]=e[n].add(o):e[n]=o}),t.each(e,function(){this.matchHeight(!0)})};var s=function(e){r._beforeUpdate&&r._beforeUpdate(e,r._groups),t.each(r._groups,function(){r._apply(this.elements,this.options)}),r._afterUpdate&&r._afterUpdate(e,r._groups)};r._update=function(n,a){if(a&&"resize"===a.type){var i=t(window).width();if(i===e)return;e=i;
			}n?o===-1&&(o=setTimeout(function(){s(a),o=-1},r._throttle)):s(a)},t(r._applyDataApi);var h=t.fn.on?"on":"bind";t(window)[h]("load",function(t){r._update(!1,t)}),t(window)[h]("resize orientationchange",function(t){r._update(!0,t)})});

			/* pajinate.js */
			(function($){$.fn.pajinate=function(options){var current_page="current_page";var items_per_page="items_per_page";var meta;var defaults={item_container_id:".content",items_per_page:10,nav_panel_id:".page_navigation",nav_info_id:".info_text",num_page_links_to_display:20,start_page:0,wrap_around:false,nav_label_first:"First",nav_label_prev:"Prev",nav_label_next:"Next",nav_label_last:"Last",nav_order:["first","prev","num","next","last"],nav_label_info:"Showing {0}-{1} of {2} results",show_first_last:true,abort_on_small_lists:false,jquery_ui:false,jquery_ui_active:"ui-state-highlight",jquery_ui_default:"ui-state-default",jquery_ui_disabled:"ui-state-disabled"};var options=$.extend(defaults,options);var $item_container;var $page_container;var $items;var $nav_panels;var total_page_no_links;var jquery_ui_default_class=options.jquery_ui?options.jquery_ui_default:"";var jquery_ui_active_class=options.jquery_ui?options.jquery_ui_active:"";var jquery_ui_disabled_class=options.jquery_ui?options.jquery_ui_disabled:"";return this.each(function(){$page_container=$(this);$item_container=$(this).find(options.item_container_id);$items=$page_container.find(options.item_container_id).children();if(options.abort_on_small_lists&&options.items_per_page>=$items.length)return $page_container;meta=$page_container;meta.data(current_page,0);meta.data(items_per_page,options.items_per_page);var total_items=$item_container.children().length;var number_of_pages=Math.ceil(total_items/options.items_per_page);var more='<span class="ellipse more">...</span>';var less='<span class="ellipse less">...</span>';var first=!options.show_first_last?"":'<a class="first_link '+jquery_ui_default_class+'" href="">'+options.nav_label_first+"</a>";var last=!options.show_first_last?"":'<a class="last_link '+jquery_ui_default_class+'" href="">'+options.nav_label_last+"</a>";var navigation_html="";for(var i=0;i<options.nav_order.length;i++){switch(options.nav_order[i]){case"first":navigation_html+=first;break;case"last":navigation_html+=last;break;case"next":navigation_html+='<a class="next_link '+jquery_ui_default_class+'" href="">'+options.nav_label_next+"</a>";break;case"prev":navigation_html+='<a class="previous_link '+jquery_ui_default_class+'" href="">'+options.nav_label_prev+"</a>";break;case"num":navigation_html+=less;var current_link=0;while(number_of_pages>current_link){navigation_html+='<a class="page_link '+jquery_ui_default_class+'" href="" longdesc="'+current_link+'">'+(current_link+1)+"</a>";current_link++}navigation_html+=more;break;default:break}}$nav_panels=$page_container.find(options.nav_panel_id);$nav_panels.html(navigation_html).each(function(){$(this).find(".page_link:first").addClass("first");$(this).find(".page_link:last").addClass("last")});$nav_panels.children(".ellipse").hide();$nav_panels.find(".previous_link").next().next().addClass("active_page "+jquery_ui_active_class);$items.hide();$items.slice(0,meta.data(items_per_page)).show();total_page_no_links=$page_container.find(options.nav_panel_id+":first").children(".page_link").length;options.num_page_links_to_display=Math.min(options.num_page_links_to_display,total_page_no_links);$nav_panels.children(".page_link").hide();$nav_panels.each(function(){$(this).children(".page_link").slice(0,options.num_page_links_to_display).show()});$page_container.find(".first_link").click(function(e){e.preventDefault();movePageNumbersRight($(this),0);gotopage(0)});$page_container.find(".last_link").click(function(e){e.preventDefault();var lastPage=total_page_no_links-1;movePageNumbersLeft($(this),lastPage);gotopage(lastPage)});$page_container.find(".previous_link").click(function(e){e.preventDefault();showPrevPage($(this))});$page_container.find(".next_link").click(function(e){e.preventDefault();showNextPage($(this))});$page_container.find(".page_link").click(function(e){e.preventDefault();gotopage($(this).attr("longdesc"))});gotopage(parseInt(options.start_page));toggleMoreLess();if(!options.wrap_around)tagNextPrev()});function showPrevPage(e){new_page=parseInt(meta.data(current_page))-1;if($(e).siblings(".active_page").prev(".page_link").length==true){movePageNumbersRight(e,new_page);gotopage(new_page)}else if(options.wrap_around){gotopage(total_page_no_links-1)}}function showNextPage(e){new_page=parseInt(meta.data(current_page))+1;if($(e).siblings(".active_page").next(".page_link").length==true){movePageNumbersLeft(e,new_page);gotopage(new_page)}else if(options.wrap_around){gotopage(0)}}function gotopage(page_num){page_num=parseInt(page_num,10);var ipp=parseInt(meta.data(items_per_page));var start_from=page_num*ipp;var end_on=start_from+ipp;var items=$items.hide().slice(start_from,end_on);items.show();$page_container.find(options.nav_panel_id).children(".page_link[longdesc="+page_num+"]").addClass("active_page "+jquery_ui_active_class).siblings(".active_page").removeClass("active_page "+jquery_ui_active_class);meta.data(current_page,page_num);var $current_page=parseInt(meta.data(current_page)+1);var total_items=$item_container.children().length;var $number_of_pages=Math.ceil(total_items/options.items_per_page);$page_container.find(options.nav_info_id).html(options.nav_label_info.replace("{0}",start_from+1).replace("{1}",start_from+items.length).replace("{2}",$items.length).replace("{3}",$current_page).replace("{4}",$number_of_pages));toggleMoreLess();tagNextPrev();if(typeof options.onPageDisplayed!=="undefined"){options.onPageDisplayed.call(this,page_num+1)}}function movePageNumbersLeft(e,new_p){var new_page=new_p;var $current_active_link=$(e).siblings(".active_page");if($current_active_link.siblings(".page_link[longdesc="+new_page+"]").css("display")=="none"){$nav_panels.each(function(){$(this).children(".page_link").hide().slice(parseInt(new_page-options.num_page_links_to_display+1),new_page+1).show()})}}function movePageNumbersRight(e,new_p){var new_page=new_p;var $current_active_link=$(e).siblings(".active_page");if($current_active_link.siblings(".page_link[longdesc="+new_page+"]").css("display")=="none"){$nav_panels.each(function(){$(this).children(".page_link").hide().slice(new_page,new_page+parseInt(options.num_page_links_to_display)).show()})}}function toggleMoreLess(){if(!$nav_panels.children(".page_link:visible").hasClass("last")){$nav_panels.children(".more").show()}else{$nav_panels.children(".more").hide()}if(!$nav_panels.children(".page_link:visible").hasClass("first")){$nav_panels.children(".less").show()}else{$nav_panels.children(".less").hide()}}function tagNextPrev(){if($nav_panels.children(".last").hasClass("active_page")){$nav_panels.children(".next_link").add(".last_link").addClass("no_more "+jquery_ui_disabled_class)}else{$nav_panels.children(".next_link").add(".last_link").removeClass("no_more "+jquery_ui_disabled_class)}if($nav_panels.children(".first").hasClass("active_page")){$nav_panels.children(".previous_link").add(".first_link").addClass("no_more "+jquery_ui_disabled_class)}else{$nav_panels.children(".previous_link").add(".first_link").removeClass("no_more "+jquery_ui_disabled_class)}}}})(jQuery);

			$(document).ready(function() {

				// mobile menu
				$(".mobile-menu-toggle").click(function() {
					$(".mobile-menu-popup").toggleClass("mobile-visible");
					return false;
				});

				$(".mobile-header-nav .close").click(function() {
					$(".mobile-menu-popup").removeClass("mobile-visible");
					return false;
				});

				$(".mobile-nav li.level1 > a").click(function (e) {
					e.preventDefault();
					if (!$(this).parent().find("ul").hasClass("open")) {
						$(".mobile-nav li.level1 ul").slideUp().removeClass("open");
						$(".mobile-nav li.level1").removeClass("open");
						$(this).parent().find("ul").slideDown().addClass("open");
						$(this).parent().addClass("open");
					} else {
						$(this).parent().find("ul").slideUp().removeClass("open");
						$(this).parent().removeClass("open");
					}
				})

				$(window).scroll(function() {
					if ($(window).width() < 991) {
						if ($(window).scrollTop() > 100) {
							if (!$(".mobile-menu-sticky").hasClass("visible")) {
								$(".mobile-menu-sticky").addClass("visible");
							}
						} else {
							$(".mobile-menu-sticky").removeClass("visible");
						}
					}

				});



				var od;

				if ($("#odometer_init_value_ajax_link").length > 0) {
					$.ajax({
						type : "get",
						dataType : "json",
						url : $("#odometer_init_value_ajax_link").val(),
						success: function(response) {
							odometer.innerHTML = response;
							$("#modal_deed_num,#modal_odometer").text(response);
						}
					});
				}

				if ($("#odometer_init_value").length > 0) {
					odometer.innerHTML = $("#odometer_init_value").val();
				}


				if ($(".recaptchaResponse").length > 0) {
					$.getScript('https://www.google.com/recaptcha/api.js?render=6Lf55acZAAAAACdjJ8p59KVJE5GY85karvaRR5eN',function() {
						grecaptcha.ready(function () {
							grecaptcha.execute('6Lf55acZAAAAACdjJ8p59KVJE5GY85karvaRR5eN', { action: 'contact' }).then(function (token) {
								$(".recaptchaResponse").val(token);
							});
						});
						$(".recaptchaResponse").closest("form").submit(function() {
							grecaptcha.execute('6Lf55acZAAAAACdjJ8p59KVJE5GY85karvaRR5eN', { action: 'contact' }).then(function (token) {
								$(".recaptchaResponse").val(token);
							});
						});
					});
				}

				// $('#gallery_pagination').pajinate({
				//      items_per_page: 9,
				//      item_container_id: "#gallery_items",
				//      start_page: 0
				//   });


				$(".ncookiepopup").click(function() {
					$(".ncookie").addClass("show");
					return false;
				});

				$(".main-cards-container .product-quote").matchHeight();

				var deeds_show_items = $("#deeds-update").data("shown-num");
				var deeds_increase_items = $("#deeds-update").data("shown-increase-num");
				$('.deeds_list .deed').slice(0, deeds_show_items).show();
				$('#loadMoreDeeds').on('click', function (e) {
					e.preventDefault();
					deeds_show_items += deeds_increase_items;
					$('.deeds_list .deed').slice(0, deeds_show_items).slideDown();
					if (deeds_show_items >= $('.deeds_list .deed').length) {
						$('#loadMoreDeeds').remove();
					}
					setTimeout(function () {
						$(".deed_label").matchHeight();
						$(".deed .custom-control-label").matchHeight();
					},500);
				});

				setTimeout(function () {
					$(".deed_label").matchHeight();
					$(".deed .custom-control-label").matchHeight();
				},100);

				// ob loadu odkljukaš tiste, ki so v localstorage
				if ($(".deed .custom-control-input").length > 0) {
					var deeds = window.localStorage.getItem("deeds");
					if (deeds == null) {
						deeds = [];
					} else {
						deeds = JSON.parse(deeds);
					}
					for (var i=0; i<deeds.length; i++) {
						if (deeds[i]) {
							$(".deed .custom-control-input#"+deeds[i]).prop('checked', true);
						}
					}
				}

				// ob spremembi spremeniš vrednost in post-aš na backend
				$(".deed .custom-control-input").on("change",function (e) {
					var deeds = window.localStorage.getItem("deeds");
					if (deeds == null) {
						deeds = [];
					} else {
						deeds = JSON.parse(deeds);
					}

					var checked = $(this).is(":checked");
					var _id = $(this).attr("id");

					var newDeeds = [];
					var exist = false;
					for (var i=0; i<deeds.length; i++) {
						if (deeds[i] == _id) {
							exist = true;
							if (checked) {
								newDeeds.push(deeds[i]);
							}
						} else {
							newDeeds.push(deeds[i]);
						}
					}
					if (checked && !exist) {
						newDeeds.push(_id);
					}

					var new_odo_value = 0;

					$.ajax({
						type : "post",
						dataType : "json",
						url : ajaxurl,
						data : {
							'action' : 'update_good_deed',
							'checked' : checked,
							'post_id' : $("#deeds-update").attr("data-post-id"),
							'nonce' : $("#deeds-update").attr("data-nonce")
						},
						success: function(response) {
							odometer.innerHTML = response;
							new_odo_value = response;

							if (checked) {
								$('#checkDeedModal').modal("show").on('shown.bs.modal', function (e) {
									$("#modal_deed_num").text(new_odo_value);
									var el = document.querySelector('#modal_odometer');
									od = new Odometer({
										el: el
									});
									od.update(response);

									var _href = $("#deeds_count_share_link").attr("href").split("count%3D");
									$("#deeds_count_share_link").attr("href",_href[0]+"count%3D"+response);

								})
							}
						}
					});

					window.localStorage.setItem("deeds",JSON.stringify(newDeeds));

					setTimeout(function () {
						$(".deed .custom-control-label").matchHeight();
					},100);

					return false;
				});

				$("#submitIdeaModal").on("hidden.bs.modal", function () {
					window.location.reload();
				})


				$("#quiz-west-form").submit(function() {

					var valid = true;
					$(this).find("input,select").each(function() {
						if (! $(this)[0].checkValidity()) {
							$(this).parent().find('.invalid-feedback').slideDown();
							valid = false
						} else {
							$(this).parent().find('.invalid-feedback').slideUp();
						}
					});

					if (valid) {
						// gigya

						var gigyaData = {};
						gigyaData['email'] = $(this).find("#email").val();

						gigyaData['subscribtions'] = [];
						var lists = $(this).attr("data-gigya-lists").split(",");
						for (var i=0; i<lists.length; i++) {
							gigyaData['subscribtions'].push(lists[i]);
						}

						if ($(this).attr("data-gigya-country")) {
							gigyaData['country'] = $(this).attr("data-gigya-country");
						}
						if ($(this).attr("data-gigya-country")) {
							gigyaData['mainLanguage'] = $(this).attr("data-gigya-language");
						}
						if ($(this).attr("data-gigya-activation")) {
							gigyaData['activationName'] = $(this).attr("data-gigya-activation");
						}


						gigyaData['action'] = 'gigya_subscribe';

						/*$.ajax({
							 type : "post",
							 dataType : "json",
							 url : ajaxurl,
							 data : gigyaData,
							 success: function(response) {
									$("#newsletter_signup").slideUp({
										'complete': function() {
											$("#newsletter_success").slideDown();
											$('html, body').animate({
												scrollTop: parseInt($("#newsletter_success").offset().top) - 65
											}, 500);
										}
									});
							 }
						});*/

					}
					return false;
				});

				$("select.video-archive-section").change(function() {
					var target = $(this).val();
					$(".video-gallery.video-archive .video-element").hide();
					$(".video-gallery.video-archive .video-element."+target).slideDown();
				});


				if ($(".slider__item video").length > 0 && typeof($(".slider__item video")[0]) != 'undefined') {
					$(".slider__item video")[0].play();
					$(".slider__item video")[0].autoplay = true;
					$(".slider__item video")[0].loop = true;
				}

				$('body.exclusive2020 a[href="#a2"]').click(function() {
					$(".accordion-info-container [data-accordion-item=1] .js-accordion-opener").click();
				});
				$('body.exclusive2020 a[href="#a3"]').click(function() {
					$(".accordion-info-container [data-accordion-item=2] .js-accordion-opener").click();
				});

				/* 2020 - new way of handling Gigya forms */
				$('[data-gigya="newsletter-desktop"] [data-gigya-submit],[data-gigya="newsletter-mobile"] [data-gigya-submit]').on('click submit',function (e) {
					e.preventDefault();
					e.stopPropagation();

					var wrapper = $(this).closest('.subscription');

					var gigyaData = {};

					var target = $(this).attr("data-gigya-submit");

					gigyaData['email'] = wrapper.find("[data-gigya='"+target+"'] input[name=email]").val();

					gigyaData['subscribtions'] = [];
					wrapper.find("[data-gigya='"+target+"'] input[name='product_line[]']").each(function() {
						if ($(this).prop("checked")) {
							gigyaData['subscribtions'].push($(this).attr("value"));
						}
					});


					if (gigyaData.subscribtions.length > 0 && gigyaData.email) {
						gigyaData['action'] = 'gigya_subscribe';

						//console.log("Gigya data: ", gigyaData );

						/*$.ajax({
							type : "post",
							dataType : "json",
							url : ajaxurl,
							data : gigyaData,
							success: function(response) {
								// handle .. perhaps?
							}
						});*/

					}
					return false;

				});


				/* 2022 - new way of handling Infobip forms - Newsletter form  */
				$('[data-infobip="form"] [data-infobip-submit]').on('click submit',function (e) {
					e.preventDefault();
					e.stopPropagation();

					const wrapper = $(this).closest('.subscription');

					const target = $(this).attr("data-infobip-submit");

					//Get email
					const getemail = wrapper.find("[data-infobip='"+target+"'] input[name=email]").val();

					//Get gdpr
					const getgdpr = wrapper.find("[data-infobip='"+target+"'] #checkTermsDesktop").val();
					const getgdprChecked = wrapper.find("[data-infobip='"+target+"'] #checkTermsDesktop");

					//Get argeta lines
					const argetaLines = [];
					wrapper.find("[data-infobip='"+target+"'] input[name='product_line[]']").each(function() {
						if ($(this).prop("checked")) {
							argetaLines.push($(this).attr("id"));
						}
					});
					//Get date
					const date = new Date();
					var datestring = date.getFullYear() + "-" + (date.getMonth()+1) + "-" + date.getDate();

					//Get language
					const getlanguage = wrapper.find("[data-infobip='"+target+"'] input[name=language]").val();

					//Get country
					const getcountry = wrapper.find("[data-infobip='"+target+"'] input[name=country]").val();

					const infobipData = InfobipApiData(
						getemail ? getemail : null,
						null,
						null,
						null,
						getcountry ? getcountry : "",
						null,
						null,
						null,
						getlanguage ? getlanguage : "",
						"newsletter",
						"Argeta",
						null,
						null,
						date ? datestring : "",
						date ? datestring : "",
						null,
						getgdprChecked.prop("checked") ? true : false,
						null,
						null,
						null,
						true,
						argetaLines.length > 0 ? argetaLines.includes("Argetajunior") : false,
						argetaLines.length > 0 ? argetaLines.includes("ArgetaVeggie") : false,
						argetaLines.length > 0 ? argetaLines.includes("Argeta") : false,
						argetaLines.length > 0 ? argetaLines.includes("ArgetaExclusive") : false,
						getemail ? getemail : null,
						null);

					if (getemail && getgdprChecked.prop("checked") && argetaLines.length > 0 ) {
						//console.log("Data: ",infobipData)
						InfobipApiCall(infobipData);
					}

				});

			});

		};

	module.init = init;

	return module;



};

export default customJquery();


